// "use client";
// import React from "react";
// import { Icon } from "@iconify/react";
// import parse from "html-react-parser";

// import useLatestBlog from "./useLatestBlog";

// import { ViewImage } from "@/components";

// const LatestBlog = () => {
//   const { allBlogs, categories, blogLoading, viewBlog } = useLatestBlog();

//   return (
//     <>
//       {allBlogs?.data && allBlogs?.data?.length > 0 && (
//         <div className="bg-foreground-50 rounded-3xl p-8 mt-5">
//           {!blogLoading ? (
//             <>
//               {allBlogs?.data && (
//                 <div>
//                   <div className="flex items-center space-x-6">
//                     <div className=" text-sm text-foreground-600 whitespace-nowrap">
//                       {new Date(
//                         allBlogs?.data[0]?.createdAt as string,
//                       ).toDateString()}
//                     </div>
//                     <div className="text-sm text-primary capitalize">
//                       {categories?.find(
//                         (cat: { _id: string }) =>
//                           cat._id === allBlogs?.data[0]?.category,
//                       )?.name ?? "—"}
//                     </div>
//                   </div>
//                   <div className=" grid md:grid-cols-2 mt-5 gap-10 items-center">
//                     <div className="">
//                       <div className="md:text-3xl text-2xl font-bold">
//                         {allBlogs?.data[0]?.title}
//                       </div>
//                       <div className=" mt-6 ">
//                         <div className="space-y-5 hidden lg:block">
//                           {typeof allBlogs?.data[0]?.content === "string"
//                             ? parse(
//                                 allBlogs?.data[0]?.content?.length > 700
//                                   ? allBlogs?.data[0]?.content.slice(0, 700) +
//                                       "..."
//                                   : allBlogs?.data[0]?.content,
//                               )
//                             : null}
//                         </div>

//                         <div className="mt-6 space-y-5 lg:hidden block">
//                           {typeof allBlogs?.data[0]?.content === "string"
//                             ? parse(
//                                 allBlogs?.data[0]?.content?.length > 100
//                                   ? allBlogs?.data[0]?.content.slice(0, 100) +
//                                       "..."
//                                   : allBlogs?.data[0]?.content,
//                               )
//                             : null}
//                         </div>
//                         <button
//                           className="flex mt-6 space-x-1 text-primary items-center font-medium cursor-pointer"
//                           onClick={() =>
//                             viewBlog(allBlogs?.data[0]?.slug as string)
//                           }
//                         >
//                           <span>Read the story</span>{" "}
//                           <Icon icon="ri:arrow-right-s-line" />
//                         </button>
//                       </div>
//                     </div>
//                     <ViewImage
//                       className="w-full object-cover  h-screen-35"
//                       img={allBlogs?.data[0]?.featuredImage}
//                     />
//                   </div>
//                 </div>
//               )}
//             </>
//           ) : (
//             <div className="w-full flex items-center justify-center">
//               Loading....
//             </div>
//           )}
//         </div>
//       )}
//     </>
//   );
// };

// export default LatestBlog;

"use client";

import React from "react";
import { Icon } from "@iconify/react";
import parse from "html-react-parser";
import { motion } from "framer-motion";
import { Button } from "@heroui/button";

import useLatestBlog from "./useLatestBlog";

import { ViewImage } from "@/components";

const LatestBlog = () => {
  const { allBlogs, categories, blogLoading, viewBlog } = useLatestBlog();

  const latestBlog = allBlogs?.data?.[0];

  const category =
    categories?.find((cat: { _id: string }) => cat._id === latestBlog?.category)
      ?.name ?? "General";

  return (
    <>
      {allBlogs?.data && allBlogs?.data?.length > 0 && (
        <motion.div
          className="relative mt-10"
          initial={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          whileInView={{ opacity: 1, y: 0 }}
        >
          {!blogLoading ? (
            <>
              {latestBlog && (
                <div className="relative ">
                  {/* content card */}
                  <div
                    className="
                      ml-auto
                      w-full
                      lg:w-[82%]
                      rounded-[32px]
                      bg-primary/5
                      p-6 md:p-10 lg:pl-[36%]
                      shadow-sm
                    "
                  >
                    <div className="max-w-xl lg:ml-auto">
                      {/* category */}
                      <div
                        className="
                          mb-5
                          w-fit
                          rounded-full
                          border border-primary/10
                          bg-background
                          px-4 py-2
                          text-xs font-medium
                          text-primary
                          capitalize
                        "
                      >
                        {category}
                      </div>

                      {/* title */}
                      <h1
                        className="
                          text-lg md:text-2xl
                          font-medium
                          leading-tight
                          tracking-[-0.05em]
                          text-primary
                        "
                      >
                        {latestBlog?.title}
                      </h1>

                      {/* meta */}
                      <div className="mt-5 flex items-center gap-3 text-sm text-neutral-500">
                        <span>
                          {new Date(
                            latestBlog?.createdAt as string,
                          ).toDateString()}
                        </span>

                        <span className="h-1 w-1 rounded-full bg-neutral-300" />

                        <span>Latest article</span>
                      </div>

                      {/* content */}
                      <div
                        className="
                          mt-7
                          line-clamp-6
                          text-sm md:text-base
                          leading-8
                          text-neutral-600
                        "
                      >
                        {typeof latestBlog?.content === "string"
                          ? parse(
                              latestBlog?.content?.length > 450
                                ? latestBlog?.content.slice(0, 450) + "..."
                                : latestBlog?.content,
                            )
                          : null}
                      </div>

                      {/* button */}
                      <div className="mt-10">
                        <Button
                          className="
                            border-primary/20
                            bg-background
                            px-5
                            text-sm font-medium
                            text-primary
                          "
                          endContent={
                            <Icon
                              className="text-base"
                              icon="lucide:arrow-up-right"
                            />
                          }
                          radius="full"
                          variant="bordered"
                          onPress={() => viewBlog(latestBlog?.slug as string)}
                        >
                          Read article
                        </Button>
                      </div>
                    </div>
                  </div>

                  {/* floating image */}
                  <motion.div
                    className="
                      relative
                      mt-6
                      lg:absolute
                      lg:left-0
                      lg:top-6
                      lg:mt-0
                      lg:w-[52%]
                    "
                    transition={{ duration: 0.3 }}
                    whileHover={{ y: -5 }}
                  >
                    <div className="overflow-hidden rounded-[28px] shadow-xl">
                      <motion.div
                        transition={{ duration: 0.5 }}
                        whileHover={{ scale: 1.04 }}
                      >
                        <ViewImage
                          className="
                            h-[280px] md:h-[420px]
                            w-full
                            object-cover
                          "
                          img={latestBlog?.featuredImage}
                        />
                      </motion.div>
                    </div>
                  </motion.div>
                </div>
              )}
            </>
          ) : (
            <div className="flex w-full items-center justify-center py-20">
              <div className="text-sm text-neutral-500">
                Loading latest article...
              </div>
            </div>
          )}
        </motion.div>
      )}
    </>
  );
};

export default LatestBlog;
